const Loading = () => (
  <div className="loading-spinner">
    <div data-uk-spinner="ratio: 3;"></div>
  </div>
);

export default Loading;
